import React from "react";

// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
// LogsErrorBoundary (#247) — isolates a single log source's render so a backend
// hiccup (e.g. a Convex query throwing "Server Error", or the function not being
// deployed to the environment the app reads) shows a message instead of crashing
// the whole Log viewer — and, critically, does NOT take down the OTHER source
// (one log group stayed dark because another source threw and killed the
// shared screen). Key this boundary by source id so switching sources remounts it
// and clears a prior error.
//
// Leland's hard rule: the Logs button must NEVER crash the app.
// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -

class LogsErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // Log for diagnostics; never rethrow.
    // eslint-disable-next-line no-console
    console.warn("LogsErrorBoundary caught:", error?.message || error, info?.componentStack?.split("\n")[1]?.trim());
  }

  render() {
    if (this.state.error) {
      return (
        <div className="text-sm p-4 border-2 border-skin-base rounded-sm">
          <div className="text-red font-medium mb-1">
            Couldn’t load {this.props.label || "these logs"}.
          </div>
          <div className="text-skin-link text-xs">
            The log source returned an error. Try another source, or check back
            shortly. The rest of the viewer is unaffected.
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default LogsErrorBoundary;
